module.exports = __webpack_public_path__ + "img/Trans_BK_Pina.efd2ea88.png";